import {combineReducers, createStore} from 'redux'
import {configureStore} from "@reduxjs/toolkit";
// import AppReducer from "./reducer";// 导入 SidebarCollapsedReducers
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import {useSelector} from "react-redux";
import Login from "../views/pages/login/Login";

const initialState = {
  sidebarShow: true,
  cusShowDetail: false,
}
// const persistConfig = {
//   // 注意这里 persistConfig
//   key: "root",
//   storage ,
//   whitelist: ['username']
// };
const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}
// const changeState2= (state = initialState, { type, ...rest }) => {
//   switch (type) {
//     case 'redux':
//       return { ...state, ...rest }
//     default:
//       return state
//   }
// }

// const reducer = combineReducers({
//   changeState
// });


// const persistedReducer = persistReducer(persistConfig, reducer);
// const store = configureStore({reducer:reducer});
const store = configureStore({
  reducer:changeState
});
// const persisstore = persistStore(store);

export { store };
